import {call, select} from "redux-saga/effects";
import axios from "axios";
import qs from "query-string";
import { getConfig } from "../services/environment";

export const Method = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

export function* request(options) {
  const res = yield call(requestApi, options);
  return res;
}

export const requestApi = async (options) => {
  try {
    const config = getConfig;
    const optionConfig = { ...options };
    optionConfig.url = `${config.baseUrl}${options.url}`;

    const contentType = optionConfig.headers?.["Content-Type"] || "";
    if (optionConfig.data && contentType.toLowerCase() === "application/x-www-form-urlencoded") {
      optionConfig.data = qs.stringify(optionConfig.data);
    }

    return await axios(optionConfig);
  } catch (err) {
    throw err.response || err;
  }
};

export function* callApi(options) {
  const { loginState } = yield select();
  const config = getConfig;
  let optionConfig = {
    ...options,
    headers: {
      ...options.headers,
      "Authorization": `Bearer ${loginState.access_token}`,
      'Accept': 'application/json',
    }
  };

  optionConfig.url = `${config.baseUrl}/api/v1${options.url}`
  const res = yield call(requestCallApi, optionConfig)
  return res
}
export function* callApiWithNoAuth(options) {
  const config = getConfig;
  let optionConfig = {
    ...options,
    headers: {
      ...options.headers,
      "Authorization": `null`,
      'Accept': 'application/json',
    }
  };

  optionConfig.url = `${config.baseUrl}/api/v1${options.url}`
  const res = yield call(requestCallApi, optionConfig)
  return res
}

export function* callApiWithNoAuthAPi(options) {
  const config = getConfig;
  let optionConfig = {
    ...options,
    headers: {
      ...options.headers,
      'Accept': 'application/json',
    }
  };

  optionConfig.url = `${config.baseUrl}/api/v1${options.url}`
  const res = yield call(requestCallApi, optionConfig)
  return res
}

export const requestCallApi = async (options) => {
  try {
    const response = await axios(options);
    return response;

  } catch (err) {
    throw err.response;
  }
}

export function* callApiV2(options) {
  const { loginState, homeState } = yield select();
  const config = getConfig;
  let optionConfig = {
    ...options,
    headers: {
      ...options.headers,
      "Authorization": `Bearer ${loginState.access_token}`,
      'Accept': 'application/json',
      'X-Client-Realm': homeState.customerName,
    }
  };

  optionConfig.url = `${config.baseUrl}/api/v2${options.url}`;
  const res = yield call(requestCallApi, optionConfig);
  return res;
}

export function* callApiV2WithNoAuth(options) {
  const { homeState } = yield select();
  const config = getConfig;
  let optionConfig = {
    ...options,
    headers: {
      ...options.headers,
      'Accept': 'application/json',
      'X-Client-Realm': homeState.customerName,
    }
  };

  optionConfig.url = `${config.baseUrl}/api/v2${options.url}`;
  const res = yield call(requestCallApi, optionConfig);
  return res;
}
